export default __webpack_public_path__ + "static/bg_office-dc71cf0a5ce8f14eed64a4716bd1a6fd.jpg";